import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Fires a Meta Pixel PageView on client-side route changes.
 * Skips the initial mount because the base pixel script in index.html
 * already sends a PageView on the first page load.
 */
export const MetaPixelRouter = () => {
  const { pathname } = useLocation();
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", "PageView");
    }
  }, [pathname]);

  return null;
};
